<template>
  <div class="skip-width flex w-full h-20 mx-auto">
    <div class="ml-auto mr-20">
      <span @click="skipForward" :class="linkTextColor" class="text-4xl font-bold cursor-pointer">Skip</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroSkipButton",
  props:{
    textColor:{
      required: false,
      type: String,
      default: 'red'
    }
  },
  methods:{
    skipForward(){
      Event.$emit('skipIntroForward');
    }
  },
  computed: {
  linkTextColor: function () {
    return {
      'text-red-500': this.textColor == 'red',
      'text-yellow-500': this.textColor == 'yellow',
    }
  }
 }
}
</script>

<style lang="css" scoped>
.skip-width{
  max-width: 1600px;
}
</style>
